const getInviteLink = async (oid, user_id, token, prefix) => {
  const url = `${prefix}organisations/${oid}/invite-link/${user_id}`;
  const response = await fetch(url, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
  if (!response.ok) throw new Error("Failed to get invite link");
  const data = await response.json();
  return data.link;
};

export default getInviteLink;
